<template>
  <div class="preview-container">
    <img v-if="isImage" :src="previewLink" class="preview-img" alt="Sertifika"/>
    <iframe v-else-if="isCertificationPreview" :src="previewLink" class="preview-iframe" frameborder="0"/>
    <PdfViewer v-else-if="previewLink" :src="previewLink"/>
  </div>
</template>

<script>
import PdfViewer from "@/view/components/ui/PdfViewer.vue";

export default {
  name: "CertificatePreview",
  components: { PdfViewer },
  props: {
    previewLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    isImage() {
      if (!this.previewLink) return false;
      return /\.(png|jpe?g|gif|webp|svg|bmp)(\?.*)?$/i.test(this.previewLink);
    },
    isCertificationPreview() {
      if (!this.previewLink) return false;
      return /\/certification\/preview\//i.test(this.previewLink);
    }
  }
}
</script>

<style scoped>
.preview-container {
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.preview-container .pdf-viewer {
  width: 100%;
}

.preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
}

.preview-iframe {
  width: 100%;
  min-height: 70vh;
  max-height: 80vh;
  border: none;
  border-radius: 4px;
}
</style>
